import AssistenciaSocialService from '@/services/AssistenciaSocialService'

export const assistenciaSocial = {
  namespaced: true,
  actions: {
    buscarVagasAcolhimentoPorSubprefeituraNoUltimoMes () {
      return AssistenciaSocialService.buscarVagasAcolhimentoPorSubprefeituraNoUltimoMes()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarVagasAcolhimentoConsolidadoUltimoMes () {
      return AssistenciaSocialService.buscarVagasAcolhimentoConsolidadoUltimoMes()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    buscarPerfisOcupacoesAgrupadosNoUltimoMes ({ dispatch }, { agrupamento }) {
      return AssistenciaSocialService.buscarPerfisOcupacoesAgrupadosNoUltimoMes({ agrupamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    vagasAcolhimentoHistoricoConsolidado ({ dispatch }, { agrupamento }) {
      return AssistenciaSocialService.vagasAcolhimentoHistoricoConsolidado({ agrupamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    vagasAcolhimentoHistoricoPorSubprefeitura ({ dispatch }, { dataInicio, dataFim, idTipoServico, idSubprefeitura, agrupamento }) {
      return AssistenciaSocialService.vagasAcolhimentoHistoricoPorSubprefeitura({ dataInicio, dataFim, idTipoServico, idSubprefeitura, agrupamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    vagasAcolhimentoHistoricoPossibilidadesFiltro ({ dispatch }, { dataInicio, dataFim, idTipoServico, idSubprefeitura, agrupamento }) {
      return AssistenciaSocialService.vagasAcolhimentoHistoricoPossibilidadesFiltro({ dataInicio, dataFim, idTipoServico, idSubprefeitura, agrupamento })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    vagasA ({ dispatch }) {
      return AssistenciaSocialService.vagasA()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    rendaBasicaEmergencial ({ dispatch }) {
      return AssistenciaSocialService.rendaBasicaEmergencial()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    censoPopulacaoDeRua ({ dispatch }) {
      return AssistenciaSocialService.censoPopulacaoDeRua()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    censoDeRuaSituacaoPorAgrupamento ({ dispatch }, { agrupamentoGeral = null, agrupamentoRegiao = null }) {
      return AssistenciaSocialService.censoDeRuaSituacaoPorAgrupamento({ agrupamentoGeral, agrupamentoRegiao })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    censoDeRuaSituacaoConsolidado ({ dispatch }) {
      return AssistenciaSocialService.censoDeRuaSituacaoConsolidado()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    censoDeRuaSituacaoConsolidadoPorIntervaloIdade ({ dispatch }, { idadeMinima = null, idadeMaxima = null }) {
      return AssistenciaSocialService.censoDeRuaSituacaoConsolidadoPorIntervaloIdade({ idadeMinima, idadeMaxima})
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },
    censoDeRuaSituacaoDetalhado ({ dispatch }) {
      return AssistenciaSocialService.censoDeRuaSituacaoDetalhado()
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
          }
        )
    },

  },
  state: {},
  mutations: {},
}
